import {
  InputNumberFloat,
  InputNumberMinMax,
  InputRandom,
} from "@components-common/forms";
import { Col, Form, Row, Table } from "taltech-styleguide";
import { Value } from "../1-building-info/building-info.types";
import { useField } from "formik";

export const LengthSelector = (props: {
  length: Value;
  id: string;
  rowNo: string;
}) => {
  const {
    length: { creationType },
    id,
    rowNo,
  } = props;
  const [field, meta, helpers] = useField(`${rowNo}.${id}.length.creationType`);
  return (
    <div className={"d-flex"} style={{ minWidth: "300px" }}>
      <div className="col-3">
        <InputNumberFloat
          id={`${rowNo}.${id}.length.value`}
          elementClass="ebd-input-width ms-2"
          showLabel={false}
          suffix=" m"
          maxValue={100}
        />
      </div>
      <div className="col-9 d-flex align-items-center">
        <Form.Group className="mx-2" style={{height: '42px'}}>
          <InputRandom
            changeFn={() => {}} //setSuccessElements(_.xor(successElements, [index]))}
            name={`${rowNo}.${id}.length.creationType`}
            value={field.value}
          />
        </Form.Group>
        {field.value === "RANDOM" && (
          <InputNumberMinMax
            elementClass={"d-flex grow-1 gap-2"}
            minId={`${rowNo}.${id}.length.options.min`}
            minLabel={"min"}
            maxId={`${rowNo}.${id}.length.options.max`}
            showLabel={false}
            suffix=" m"
          />
        )}
      </div>
    </div>
  );
};
